<template>
  <section class="container">
    <PrimarySectionTitle>
      <div class="side-by-side">
        <h2 class="border-left carret-right">{{ name }}</h2>
        <a href="#">ver mais</a>
      </div>
    </PrimarySectionTitle>
    <div class="row">
      <div class="col-lg-3 col-6 mb-3">
        <CourseThumbBox />
      </div>
      <div class="col-lg-3 col-6 mb-3">
        <CourseThumbBox />
      </div>
      <div class="col-lg-3 col-6 mb-3">
        <CourseThumbBox />
      </div>
      <div class="col-lg-3 col-6 mb-3">
        <CourseThumbBox />
      </div>
    </div>
  </section>
</template>

<script>
  import PrimarySectionTitle from '@/components/layout/PrimarySectionTitle'
  import CourseThumbBox from '@/components/course/CourseThumbBox'

  export default {
    props: {
      name: {
        type: String,
        default: null
      }
    },
    components: {
      PrimarySectionTitle,
      CourseThumbBox,
    }
  }
</script>